import React from 'react';
import { Briefcase, Ship, Settings, Trophy } from 'lucide-react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    icon: Briefcase,
    title: 'Como Conseguir Trabajo en Charter Internacional',
    desc: 'Estrategias reales para entrar al mercado de charters.'
  }, {
    icon: Ship,
    title: 'Que Vas Hacer Realmente a Bordo',
    desc: 'Todo lo que nadie te cuenta sobre la vida en el mar.'
  }, {
    icon: Settings,
    title: 'Sistema Operativo de Bordo',
    desc: 'El sistema paso a paso para operar profesionalmente.'
  }, {
    icon: Trophy,
    title: 'Como manejar un charter con exito',
    desc: 'Las claves para destacarte y crecer rápido.'
  }];
  return <section className="bg-gray-50 py-24 relative overflow-hidden" data-id="element-21">
      <div className="container mx-auto px-4 relative z-10" data-id="element-22">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-23">
          <FadeIn data-id="element-24">
            <div className="inline-block bg-red-100 text-red-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-25">
              GRATIS por hoy
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-navy-950 mb-6" data-id="element-26">
              Bonos Exclusivos
            </h2>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-16" data-id="element-27">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-28">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 h-full flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-29">
                <div className="w-16 h-16 bg-gold-50 rounded-full flex items-center justify-center mb-6" data-id="element-30">
                  <bonus.icon className="w-8 h-8 text-gold-500" data-id="element-31" />
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-33">{bonus.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-34">
          <div className="max-w-2xl mx-auto bg-navy-900 text-white rounded-3xl p-8 text-center shadow-xl" data-id="element-35">
            <p className="text-xl mb-6" data-id="element-36">
              Valor total bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-37">$99.900</span> —{' '}
              <span className="text-gold-400 font-bold text-2xl" data-id="element-38">
                Hoy GRATIS
              </span>
            </p>
            <Button size="xl" onClick={scrollToPricing} className="w-full sm:w-auto" data-id="element-39">
              👉 Quiero el pack completo + bonos
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}